export enum WidgetType {
  IN_STREAM = 'in_stream',
  FLOATER = 'floater',
  CAROUSEL = 'carousel'
}

export enum FrequencyCapPeriod {
  Daily = 'daily',
  Session = 'session',
  Hourly = 'hourly'
}

export interface Widget {
  widget_id: number
  organization_id?: number
  widget_name: string
  is_vertical: boolean
  type: WidgetType
  desktop_width?: number
  mobile_width?: number
  desktop_height?: number
  mobile_height?: number
  //is_advertising_active?: boolean
  is_sound_on?: boolean
  is_sound_on_desktop?: boolean
  is_sound_on_mobile?: boolean
  adset_is_preroll?: boolean
  adset_is_midroll: boolean
  adset_midroll_type?: string
  //repeat?: number
  //loop?: boolean
  is_responsive_desktop?: boolean
  is_responsive_mobile?: boolean
  is_mobile_active?: boolean
  playinit_method?: string
  playinit_method_mobile?: string
  floater_padding?: number
  mobile_floater_padding?: number
  is_desktop_active?: boolean
  is_active?: boolean
  create_date?: string
  floater_enabled_desktop?: boolean
  floater_frequency_cap_desktop?: number
  floater_frequency_cap_method_desktop?: string
  floater_width_desktop?: number
  floater_height_desktop?: number
  floater_location_desktop?: string
  floater_enabled_mobile?: boolean
  floater_frequency_cap_mobile?: number
  floater_frequency_cap_method_mobile?: string
  floater_width_mobile?: number
  floater_height_mobile?: number
  floater_location_mobile?: string
  volume_desktop?: number
  volume_mobile?: number
}

export interface WidgetEdit extends Widget {
  is_vertical: boolean
}

export interface CreateWidget extends Omit<Widget, 'widget_id' | 'organization_id'> {}

export interface Widgets {
  widgets: Widget[]
  total: number
}
